module.exports = __webpack_public_path__ + "img/manda_035.81fd7e49.png";